<div class="history list-view w-full">
  <div class="history-wrapper widget-bg-color px-5 content-center justify-end h-full rounded-xl">
    <h2 class="history-headline text-2xl font-bold py-5" *ngIf="showHeader">
      <ng-container i18n>History</ng-container>
      <span *ngIf="count > 0">({{ count }})</span>
    </h2>

    <!-- To show loading message, while http call is in progress -->
    <sp-loading-inprogress *ngIf="httpCallInProgress; else loadingComplete" [showSpinner]="true"></sp-loading-inprogress>
    <ng-template #loadingComplete>
      <ng-template [ngIf]="history.length > 0" [ngIfElse]="empty">
        <sp-custom-generic-table [tableName]="'history-'" [tableCols]="columns" [tableData]="history" [actionColumn]="false"></sp-custom-generic-table>
      </ng-template>
      <ng-template #empty>
        <sp-blank-page class="block pt-10 pb-8" [pageType]="pageType"></sp-blank-page>
      </ng-template>
    </ng-template>
  </div>
</div>
